import BoardNav from "./BoardNav";

export default function DiscoveryFollowingTab() {
  return <BoardNav />;
}
